import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { tap, catchError } from 'rxjs';
import { DDL } from 'src/app/core-module/models/ddl';
import { UserAudit } from 'src/app/core-module/models/UserManagement/user-audit';
import { UserAuditDetail } from 'src/app/core-module/models/UserManagement/user-audit-detail';
import { UserAuditResult } from 'src/app/core-module/models/UserManagement/user-audit-result';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { ToastrService } from 'src/app/core-module/services/toastr.service';
import { UserManagementService } from 'src/app/core-module/services/usermanagement.service';

@Component({
    selector: 'app-user-audits',
    templateUrl: './user-audits.component.html',
    styleUrl: './user-audits.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserAuditsComponent {

  public unsavedChanges: boolean = false;
  public isGroup: boolean = false;
  public isSaving: boolean = false;
  public showUsersDDL: boolean = true;
  public isLoadingAudits: boolean = false;
  public isLoadingUsers: boolean = false;

  public initialData: UserAudit[] = [];

  public _userList: UserAudit[] = [];
  public userListView: UserAudit[] = [];
  public selectedUser: UserAudit = new UserAudit();
  private _originalUser: UserAudit = new UserAudit();

  public allPermissions: boolean = false;

  public userFilterString: string = "";

  public showActionSectionBar: boolean = false;
  public userLoaded: boolean = false;

  public auditTypes: DDL[] = [];
  public currentAuditType: DDL = new DDL();

  constructor(private UMS: UserManagementService, private router: Router, private toastr: ToastrService) {
    if (this.router.url == '/settings/users/groupaudits') {
      this.isGroup = true;
    }
    this.getData();
  }
  clearAuditList() {
    //not required if remaining with UserAudit structure
  }
  checkChange() {
    this.unsavedChanges = false;
    this.selectedUser.AuditPermissions.forEach(e => {
      this._originalUser.AuditPermissions.forEach(x => {
        if (e.AuditID == x.AuditID) {
          if (e.HasPermission != x.HasPermission) {
            this.unsavedChanges = true;
            ;
          }
        }
      })

    })
  }
  buildUserView() {
    if (this.userFilterString.length == 0) {
      this.userListView = this._userList;
      return;
    }
    this.userListView = this._userList.filter(e => { return e.DisplayName.toLowerCase().includes(this.userFilterString.toLowerCase()) });
    if (this.userListView.length == 1) {
      this.selectedUser = this.userListView[0];
    }
  }
  getData() {
    this.isLoadingUsers = true;
    this.UMS.getUserAuditUserList((this.router.url == '/settings/users/groupaudits')).pipe(tap((a:UserAuditResult) => {
      if (a.IsError) {
        console.error(a.ErrorCode);
        this.toastr.addToastr(new Toastr({ Message: 'Connection Error', Type: 3 }))
      } else {
        this.initialData = a.Users;
        this.setData();
      }
      this.isLoadingUsers = false;
    }),
      catchError((err:any) => {
        this.isLoadingUsers = false;
        this.toastr.addToastr(new Toastr({ Type: 3, Message: "An error occurred collecting the information, please try again later." }));
        return err;
      })).subscribe();
    //this.UMS.getUserAudits((this.router.url == '/settings/users/groupaudits')).pipe(tap((a) => { this.initialData = a; this.setData();})).subscribe();
  }
  setData() {
    this._userList = [];
    this._userList.push(new UserAudit({ UserID: -1, DisplayName: 'Please select...' }))
    this.selectedUser = this._userList[0];
    this.initialData.forEach(e => {
      this._userList.push(new UserAudit(e));
    })
    this.buildUserView()
  }
  loadUser() {
    this.isLoadingAudits = true;
    this.UMS.getIndividualUserAudits(this.selectedUser.UserID).pipe(tap((a:UserAuditResult) => {
      if (a.IsError) {
        console.error(a.ErrorCode);
        this.toastr.addToastr(new Toastr({ Message: 'Unable to fetch user audits', Type: 3 }))
        this.isLoadingAudits = false;
      } else {
        this.assignedPermissions(a.Users[0]);

      }
    }),
      catchError((err:any) => {
        this.isLoadingAudits = false;
        this.toastr.addToastr(new Toastr({ Type: 3, Message: "An error occurred collecting the information, please try again later." }));
        return err;
      })).subscribe();
  }
  showDDL() {
    this.userLoaded = false;
    this.showUsersDDL = true;
    this.showActionSectionBar = false;
  }
  assignedPermissions(UA: UserAudit) {
    this._originalUser.AuditPermissions = [];
    this.selectedUser.AuditPermissions = [];
    UA.AuditPermissions.forEach(e => {
      this._originalUser.AuditPermissions.push(new UserAuditDetail(e));
      this.selectedUser.AuditPermissions.push(new UserAuditDetail(e));
    })
    this.userLoaded = true;
    this.showUsersDDL = false;
    this.showActionSectionBar = true;
    this.isLoadingAudits = false;
    this.buildAuditTypes();
    this.checkAllPermissions();
  }
  buildAuditTypes() {
    this.auditTypes = [];
    this.selectedUser.AuditPermissions.forEach(e => {
      if (this.auditTypes.filter(x => x.ID == e.AuditTypeID).length == 0) {
        this.auditTypes.push(new DDL({ ID: e.AuditTypeID, Description: e.AuditType }));
      }
    })
    this.auditTypes.sort((a, b) => a.Description.localeCompare(b.Description));
    this.auditTypes.unshift(new DDL({ ID: -1, Description: 'Please select...' }));
  }
  updateAllPermissions() {
    this.selectedUser.AuditPermissions.forEach(x => {
      x.HasPermission = this.allPermissions;
    })
    this.checkChange();
  }
  resetUser() {
    this.selectedUser.AuditPermissions = [];
    this._originalUser.AuditPermissions.forEach(e => {
      this.selectedUser.AuditPermissions.push(new UserAuditDetail(e));
    })
    this.checkChange();
    this.checkAllPermissions();
  }

  checkAllPermissions() {
    var permissionCheck = true;
    this.selectedUser.AuditPermissions.forEach(x => {
      if (!x.HasPermission) {
        permissionCheck = false;
      }
    });
    this.allPermissions = permissionCheck;
  }
  saveChanges() {
    this.isSaving = true;
    this.unsavedChanges = false;
    this.UMS.saveIndividualUserAudits(this.selectedUser).pipe(
      tap((a:UserAuditResult) => {
        if (a.IsError) {
          console.error(a.ErrorCode);
          this.toastr.addToastr(new Toastr({ Message: 'Unable to save user audits', Type: 3 }))
          this.unsavedChanges = true;
        } else {
          this.assignedPermissions(a.Users[0]);
          this.toastr.addToastr(new Toastr({ Message: "Changes saved.", Type: 2 }))
        }
        this.isSaving = false;
      }),
      catchError((err:any) => {
        console.error('uac001');
        this.unsavedChanges = true;
        this.isSaving = false;
        this.toastr.addToastr(new Toastr({ Type: 3, Message: "An error occurred while saving, please try again later." }));
        return err;
      })
    ).subscribe();
  }
  resetPage() {
    this.setData();
  }
  goBack() {
    this.router.navigateByUrl("/settings");
  }
}
